import Cookie from './cookie';

/**
 * User相关方法
 * @namespace User
 * @name User
 * @static
 */
const User = {};
User.get = function () {
  /**
   * 判断当前用户是否登录
   * @name User.isLogin
   * @property isLogin
   *
   * @return {Boolean} 用户登录状态
   */
  this.isLogin = (Cookie.get('UniqueKey') || Cookie.get('user_id')) !== null;
  /**
   * 当前登录用户ID
   * @name User.user_id
   * @property user_id
   *
   * @return {Boolean} 当前登录用户ID
   */
  this.user_id = Cookie.get('UniqueKey') || Cookie.get('user_id');
  /**
   * 用户是否登录过猎聘
   * @name User.is_lp_user
   * @property is_lp_user
   *
   * @return {Boolean} 用户是否登录过猎聘
   */
  this.is_lp_user = Cookie.get('is_lp_user');
  /**
   * 当前登录用户姓名
   * @name User.user_name
   * @property user_name
   *
   * @return {Boolean} 当前登录用户姓名
   */
  this.user_name = Cookie.get('user_name');
  /**
   * 当前登录用户类型
   * @name User.user_kind
   * @property user_kind
   *
   * @return {Boolean} 当前登录用户类型
   */
  this.user_kind = Cookie.get('user_kind');
  /**
   * 当前登录用户头像
   * @name User.user_photo
   * @property user_photo
   *
   * @return {Boolean} 当前登录用户头像
   */
  this.user_photo = Cookie.get('user_photo') || '55557f3b28ee44a8919620ce01a.gif';
  /**
   * 用户Socket
   * @name User.socket
   * @property socket
   *
   * @return {socket} socket
   */
  this.socket = null;
  /**
   * 判断用户是否拥有某一身份（user_roles 目前只有C端PC存在，其他端没有这个cookie慎用）
   * C_JOBHUNTER(0, "求职者")
   * E_RECRUITER(1, "企业招聘方")
   * H_RECRUITER(2, "猎头招聘方")
   * XYE(4, "校园企业")
   */
  const userRoles = Cookie.get('user_roles');
  this.isC = this.isLogin && userRoles && userRoles.includes('0');
  this.isB = this.isLogin && userRoles && userRoles.includes('1');
  this.isH = this.isLogin && userRoles && userRoles.includes('2');
};
User.get();

export default User;
